"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridOldProcessor = void 0;
const TradeAPILib_1 = require("TradeAPILib");
const react_1 = require("react");
const GridTradingUtils_1 = require("./GridTradingUtils");
const trade_utils_lib_1 = require("trade_utils_lib");
const GridUtils_1 = require("../../TradeUtils/GridUtils");
const SimpleTrading_1 = require("../SimpleTrading");
class GridOldProcessor {
    static useUserParams(top, bottom, count, perVolume, baseBalance, quoteBalance, stopLostPrice, fee, currentPrice, symbol, market, tradeAPI, botType, $st, updateSignal) {
        var _a, _b;
        const curPrice = new trade_utils_lib_1.SafeDecimal(currentPrice);
        const profitPerGrid = GridTradingUtils_1.GridTradingUtils.useProfitPerGrid("arithmetic", top, bottom, count, fee, (_a = symbol.precision) !== null && _a !== void 0 ? _a : 0);
        const calcuGridsMax = GridTradingUtils_1.GridTradingUtils.useRealMaxGridCount(top, bottom, "arithmetic", fee, (_b = symbol.precision) !== null && _b !== void 0 ? _b : 0, 150);
        const [supportStopLost, stopLost] = (0, react_1.useMemo)(() => {
            const isSupport = (0, TradeAPILib_1.checkMarketSupportStopLoss)(market);
            const stopL = isSupport ? stopLostPrice : "";
            return [isSupport, stopLostPrice];
        }, [market, stopLostPrice]);
        const [baseAvailable, quoteAvailable, totalAvailable] = (0, react_1.useMemo)(() => {
            const base = new trade_utils_lib_1.SafeDecimal(baseBalance);
            const quote = new trade_utils_lib_1.SafeDecimal(quoteBalance);
            const baseA = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(base, symbol.amount);
            const quoteA = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(quote, symbol.precision);
            const totalA = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(base.mul(curPrice).add(quote), symbol.precision);
            return [baseA, quoteA, totalA];
        }, [baseBalance, quoteBalance, symbol.amount, symbol.precision, curPrice]);
        const minPerVolume = (0, react_1.useMemo)(() => {
            if (!bottom) {
                return "";
            }
            const low = new trade_utils_lib_1.SafeDecimal(bottom).toNumber();
            const min = SimpleTrading_1.SimpleTrading.getMinAmount(symbol, low);
            if (min) {
                return trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(min, symbol.amount, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
            }
            return "";
        }, [bottom, symbol]);
        const [requiredBalance, requiredBalanceDesc, requiredBalanceLoading, requiredBalanceError] = GridUtils_1.GridUtils.useRequiredBalance(symbol, baseBalance, quoteBalance, top, bottom, perVolume, count, curPrice.toNumber(), tradeAPI, market, $st);
        const investState = (0, react_1.useMemo)(() => {
            const state = {
                state: "normal",
                min: minPerVolume,
                max: "",
            };
            if (perVolume) {
                if (new trade_utils_lib_1.SafeDecimal(perVolume).lessThan(new trade_utils_lib_1.SafeDecimal(minPerVolume))) {
                    state.state = "small";
                }
            }
            return state;
        }, [perVolume, minPerVolume]);
        const emptyErrors = (0, react_1.useMemo)(() => {
            const emptys = GridTradingUtils_1.GridTradingUtils.checkRequiredParamsEmpty(top, bottom, count);
            if (!Number(perVolume)) {
                emptys.push("trade_grid_per_volume");
            }
            return emptys;
        }, [top, bottom, count, perVolume]);
        return {
            botType,
            top,
            bottom,
            count,
            profitPerGrid,
            invest: perVolume,
            minInvest: minPerVolume,
            baseAvailable,
            quoteAvailable,
            totalAvailable,
            requiredBalance,
            requiredBalanceDesc,
            stopLostPrice: stopLost,
            supportStopLost,
            fee,
            investState,
            currentPrice,
            symbol,
            emptyErrors,
            gridType: "arithmetic",
            trend: "long",
            earnCoin: symbol.base,
            earnPrecision: symbol.amount || 0,
            useAllCoins: true,
            investPercent: 0,
            takeProfitPrice: "",
            triggerPrice: "",
            openPriceLimit: "",
            requiredBalanceError,
            requiredBalanceLoading,
            earnCoinDisplay: symbol.baseDisplay,
            calculateFee: fee,
            feeError: "",
            realMaxGrids: calcuGridsMax,
        };
    }
    static getCreateOrderRequest(params, $st) {
        const high = new trade_utils_lib_1.SafeDecimal(params.top).toNumber();
        const low = new trade_utils_lib_1.SafeDecimal(params.bottom).toNumber();
        const perV = new trade_utils_lib_1.SafeDecimal(params.invest).toNumber();
        const row = new trade_utils_lib_1.SafeDecimal(params.count).toNumber();
        const stop = params.stopLostPrice ? new trade_utils_lib_1.SafeDecimal(params.stopLostPrice).toNumber() : undefined;
        const baseBalance = new trade_utils_lib_1.SafeDecimal(params.baseAvailable).toNumber();
        const quoteBalance = new trade_utils_lib_1.SafeDecimal(params.quoteAvailable).toNumber();
        const minPerVolume = params.minInvest ? new trade_utils_lib_1.SafeDecimal(params.minInvest).toNumber() : undefined;
        const currentPrice = params.currentPrice ? new trade_utils_lib_1.SafeDecimal(params.currentPrice).toNumber() : undefined;
        const err = GridUtils_1.GridUtils.checkBalanceEnoughRequest(high, low, perV, row, baseBalance, quoteBalance, $st, stop, minPerVolume, currentPrice);
        if (err) {
            throw err;
        }
        const request = {
            base: params.symbol.base,
            quote: params.symbol.quote,
            type: params.botType,
            high: params.top,
            low: params.bottom,
            stop: params.stopLostPrice,
            amount: params.invest,
            number: params.count,
            feeRate: params.fee || undefined,
        };
        return request;
    }
}
exports.GridOldProcessor = GridOldProcessor;
